import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BreadCrumb from "../components/breadCrumb";
import CheckBox from "../components/common/CheckBox";
import ComboBoxData from "../components/common/ComboBoxData";
import ComboBoxDataMulti from "../components/common/ComboBoxDataMulti";
import { NumericBox } from "../components/common/NumericBox";
import PageContent from "../components/pageContent";
import ProductBreadCrumb from "../components/products/ProductBreadCrumb";
import TopBarWithBreadCrumb from "../components/TopBarWithBreadCrumb";
import { apiGetAllBasesByProduct } from "../services/BasesService";
import { apiGetAllColorsForSampleCard } from "../services/ColorsService";
import { apiGetAllProducts } from "../services/ProductsService";
import { apiGetSampleCardsForProduct } from "../services/SampleCardsService";
import { MultiSelect } from "react-multi-select-component";

import './KopirovaniRecepturReportPage.css';
import { TextBox } from "../components/common/TextBox";
import { apiCreateReceiptsCopyJob, apiLoadReceiptsCopyJob, apiProcessReceiptsCopyJob } from "../services/ReceiptsService";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const KopirovaniRecepturReportPage = () => {

    const { t } = useTranslation(undefined, { keyPrefix: 'CopyReceiptsReportPage' });
    const [jobIsRunning, setJobIsRunning] = useState(false);
    const jobIsRunningRef = useRef(jobIsRunning);
    jobIsRunningRef.current = jobIsRunning;
    let initJobItemsData: any;
    const [jobItemsData, setJobItemsData] = useState(initJobItemsData);
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const jobIdentifierFromUrl = params.get('jobIdentifier') || '';
    const [jobIdentifierError, setJobIdentifierError] = useState(false);

    useEffect(() => {
        if (jobIdentifierFromUrl && jobIdentifierFromUrl.length > 0) {
            loadData();
        }
        else {
            setJobIdentifierError(true);
        }
    }, []);

    const loadData = async () => {

        var jobData = await loadJobItemsData();
        var notCompletedItems = jobData.items.filter(a => a.status == "Queued");

        if (notCompletedItems && notCompletedItems.length > 0) {
            apiProcessReceiptsCopyJob(jobIdentifierFromUrl);
            setJobIsRunning(true);
            await autoLoadItemsInInterval(true);
        }
    }

    const loadJobItemsData = async () => {
        var jobData = await apiLoadReceiptsCopyJob(jobIdentifierFromUrl);
        setJobItemsData(jobData.data);
        return jobData.data;
    }

    const autoLoadItemsInInterval = async (jobIsRunningParam) => {

        let jobRunning = jobIsRunningRef.current || jobIsRunningParam;

        if (jobRunning) {

            let jobData = await loadJobItemsData();
            var notCompletedItems = jobData.items.filter(a => a.status == "Queued");

            if (notCompletedItems && notCompletedItems.length > 0) {
                setTimeout(() => autoLoadItemsInInterval(false), 1000);
            }
            else {
                setJobIsRunning(false);
            }
        }
    }

    return <>
        <PageContent>
            <>
                <TopBarWithBreadCrumb
                    contextLevel={"Receptury"}
                    pageLevel="Receptury"
                />

                <div className="row" style={{ padding: '20px' }}>
                    <div className="col-12" >
                        <div className={`card`}>
                            <div className="card-header">
                                <h3 className="copyingSectionHeader">{t('CopyingReceipts')} ({t('Job')} {jobIdentifierFromUrl})</h3>
                            </div>
                            <div className="card-body" >

                                {jobIdentifierError && <span>{t('JobCannotBeRecognized')}</span>}
                                {!jobIdentifierError && <div>
                                    <div className="card-body" >
                                        <div>{t('JobStatus')} {jobIsRunning ? 'Running' : 'Not running'}</div>
                                        <div>{t('TotalReceipts')} {jobItemsData?.totalItems || 0}</div>
                                        <div>{t('AlreadyCopied')} {jobItemsData?.completed || 0}</div>
                                        <div>{t('RemainingReceipts')} {jobItemsData?.notCompleted || 0}</div>
                                    </div>
                                    <div style={{ maxHeight: '500px', overflow: 'auto', padding: '10px', border: '1px solid lightgray' }}>
                                        {jobItemsData && jobItemsData.items.length > 0 && jobItemsData.items.map((jobItem: any) => {
                                            return <div>{jobItem.id} - {jobItem.status}</div>
                                        })}
                                    </div>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        </PageContent>
    </>
}

export default KopirovaniRecepturReportPage;